<template>
  <div>
    <div class="container py-4 py-md-5">
      <div class="placeholder" v-if="!isSearchLoaded">
        <div class="page-title mx-auto mb-3" style="width: 40%;"></div>
        <div class="paragraph mx-auto mb-4" style="width: 20%;"></div>

        <div class="row">
          <div class="col-12" v-for="index in 2" :key="index">
            <div class="search-block">
              <div class="thumbnail"></div>
              <div class="content"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isSearchLoaded">
        <h1 class="page-title text-center" v-html="$t('message.searchresult', { keyword: searchResults.query_vars.s })"></h1>
        <p class="text-center" v-html="$t('message.searchcount', { count: searchResults.found_posts })"></p>
        <div class="row">
          <div class="col-12" v-for="(result, index) in searchResults.posts" :key="index">
            <div class="search-block">
              <div class="thumbnail">
                <router-link :to="{ name: result.post_type, params: { slug: result.post_name } }">
                  <div v-lazy-container="{ selector: 'img' }">
                    <picture>
                      <source media="(max-width: 767.98px)" :srcset="result.thumbnail[0]" />
                      <img :data-src="result.post_thumbnail[0]" :alt="result.post_title" class="img-fluid">
                    </picture>
                  </div>
                </router-link>
              </div>
              <div class="content">
                <div class="content-block">
                  <div class="title">
                    <router-link :to="{ name: result.post_type, params: { slug: result.post_name } }">
                      {{ result.post_title }}
                    </router-link>
                  </div>
                  <div class="excerpt" v-html="result.post_excerpt.trim() ? result.post_excerpt : stripHTML(result.post_content)"></div>
                </div>
                <div class="link">
                  <router-link :to="{ name: result.post_type, params: { slug: result.post_name } }">
                    {{ getHostname() + $router.resolve({ name: result.post_type, params: { slug: result.post_name } }).href }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-lg-5 my-0 my-md-3">
          <Pagination :current="currentPage" :last="searchResults.max_num_pages" routeName="Search" :query="searchResults.query_vars.s" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import '@/assets/sass/search.sass'
import '@/assets/sass/pagination.sass'
import Pagination from '@/components/Templates/Pagination'
export default {
  name: 'Search',
  components: {
    Pagination
  },
  data () {
    return {
      api_path: process.env.VUE_APP_API_PATH,
      title: process.env.VUE_APP_TITLE,
      isSearchLoaded: false,
      searchResults: [],
      currentPage: this.$route.query.paged ? this.$route.query.paged : 1
    }
  },
  created () {
    const $vm = this
    const query = this.$route.params.query
    this.getSearch()
    document.title = `Search Results for "${query}" – ${$vm.title}`
  },
  methods: {
    getSearch () {
      const lang = this.$route.params.lang
      const vm = this
      vm.isSearchLoaded = false
      const query = this.$route.params.query
      const paged = this.$route.query.paged ? this.$route.query.paged : 1
      axios.get(`${this.api_path}wp-json/xilda/v1/search/${encodeURIComponent(query)}`, {
        params: {
          paged,
          lang
        }
      })
        .then(res => {
          if (res.data) {
            vm.searchResults = res.data
            vm.isSearchLoaded = true
            vm.currentPage = parseInt(paged)
          }
        })
    },
    stripHTML (content) {
      return content.replace(/<\/?[^>]+(>|$)/g, '')
    },
    getHostname () {
      return window.location.origin
    }
  },
  watch: {
    '$route' () {
      this.getSearch()
    }
  }
}
</script>
